export default [
    { title: 'Bradesco', value: '237', },
    { title: 'Citibank', value: '745', },
    { title: 'Banco do Brasil', value: '1', },
    { title: 'Banco Inter', value: '77', },
    { title: 'Safra', value: '422', },
    { title: 'Santander', value: '33', },
    { title: 'Itaú', value: '341', },
    { title: 'Nubank', value: '260', },
];